<div class="dl-video__dropdown">
    <div class="dl-video__knop" (click)="klikKnop()">
        <span class="fa-solid fa-video"[title]="'VIDEO.MAIN' | translate"></span>
    </div>
    @if (pickerOpen()) {
        <div class="dl-video__picker">
            @for (rij of pickerRijen(); track $index) {
                @if (rij.scheiding) {
                    <hr class="dl-video__scheiding">
                }
                <div class="dl-video__pickerrij">
                    @for (knop of rij.knoppen; track knop.pad) {
                        <div class="dl-video__pickerknop"
                             [class]="'dl-video__pickerknop--' + knop.cssKlasse"
                             [title]="knop.titelKey | translate"
                             (click)="pick(knop)">
                            @if (knop.cssKlasse === 'fullvideo') {
                                <span class="fa-solid fa-film"></span>
                            }
                            @if (knop.tekst) {
                                {{knop.tekst}}
                            }
                        </div>
                    }
                </div>
            }
        </div>
    }
</div>
<!--
  Video-overlay: fullscreen (onder de topbalk) met gecentreerd videokader.
  De sluitknop zit expliciet aan de videoinhoud (rechtsboven), niet aan de overlay.
  Het element wordt na de view-init naar document.body verplaatst: de host staat in het
  #sidemenu, en binnen die stacking context (z-index 600) zou de overlay onder de topbalk
  en de modals uitkomen in plaats van erboven.
-->
<div class="dl-video__overlay"
     [class.dl-video__overlay--actief]="videoStatus.speelt()"
     (click)="cancelVideo()"
     #overlay>
    @if (videoStatus.speelt()) {
        <div class="dl-video__kader">
            <button type="button"
                    class="dl-video__sluitknop"
                    title="Sluiten"
                    aria-label="Sluiten"
                    (click)="$event.stopPropagation(); cancelVideo()">
                <span class="fa-solid fa-xmark"></span>
            </button>
            <video [src]="'/resources/video/' + videoNaam()"
                   autoplay loop muted playsinline controls disablepictureinpicture
                   controlslist="nodownload nofullscreen noremoteplayback">
            </video>
        </div>
    }
</div>
